import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { assignEmployee, getCompanies } from "../../actions/companyActions";
import { getCompaniesOfEmployee } from "../../actions/employeeActions";
import { notifyErrorCompanyEmployeeAssignment } from "../../actions/companyEmployeeActions";
import { getShiftTypes } from "../../actions/shiftTypeActions";
import Form from "./Form";
import {
  Grid,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Button,
  FormHelperText,
} from "@material-ui/core";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import DeleteIcon from "@material-ui/icons/Delete";

import { KeyboardDatePicker } from "@material-ui/pickers";
import { AppContext } from "../../contexts";
import { CommuteType, EmploymentType, UserType } from "../../types/enums";

import { useTranslation } from "react-i18next";
import moment from "moment";

const credentials = JSON.parse(localStorage.getItem("credentials"));

const CreateCompanyEmployeeForm = (props) => {
  const { t } = useTranslation();

  const [state, setState] = useState({
    employmentType: "",
    commuteType: "",
    isEmployeeInEducation: false,
    isSeniorEmployee: false,
    cardPhoto: "",
    cardNumber: "",
    cardValidity: moment(),

    shiftTypes: [],
    company: " ",

    optionShiftTypes: [],
    optionCompanies: [],
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setIsLoading(true);
      const shiftTypes = await props.getShiftTypes();
      setState((prev) => ({
        ...prev,
        optionShiftTypes: shiftTypes,
      }));

      const companies =
        credentials.user.type === UserType.PERSON
          ? await props.getCompanies()
          : credentials.user.type === UserType.EMPLOYEE
            ? await props.getCompaniesOfEmployee(credentials.user.email, true)
            : null;

      setState((prev) => ({
        ...prev,
        ...(credentials.user.type !== UserType.COMPANY && {
          optionCompanies: companies,
        }),
        ...(credentials.user.type === UserType.COMPANY && {
          company: credentials.user.email,
        }),
      }));
    } catch (error) {
      setErrorMessage(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    props
      .assignEmployee({ ...state, email: props.email })
      .then(() => {
        window.location.href = `/employee`;
        setSuccessMessage("Medewerker aan bedrijf toevoegen is voltooid");
      })
      .catch(setErrorMessage)
      .finally(() => setIsLoading(false));
  };

  const notifyError = () => {
    setIsLoading(true);
    notifyError(state.company, props.email, state)
      .then(() => setSuccessMessage("Melding is succesvol verzonden."))
      .catch(setErrorMessage)
      .finally(() => setIsLoading(false));
  };

  const handleEmployeeChange = (e) => {
    e.persist();
    setState((prev) => ({ ...prev, shiftTypes: e.target.value }));
  };

  const handleChange = (e) => {
    e.persist();
    setState((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleCheckboxChange = (e) => {
    e.persist();
    setState((prev) => ({ ...prev, [e.target.name]: e.target.checked }));
  };

  const handleFileUploadChange = (e) => {
    var reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);

    reader.onload = function () {
      setState((prev) => ({ ...prev, cardPhoto: reader.result }));
    }.bind(this);
  };

  return (
    <AppContext.Consumer>
      {(settings) => (
        <Form
          onSubmit={handleSubmit}
          disabled={!!successMessage}
          submitText="Toevoegen"
          isFetching={isLoading}
          successMessage={successMessage}
          errorMessage={errorMessage}
        >
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              {credentials.user.type != "COMPANY" && (
                <Fragment>
                  <InputLabel htmlFor="company">Bedrijf *</InputLabel>
                  <Select
                    id="company"
                    name="company"
                    value={state.company}
                    onChange={handleChange}
                    fullWidth
                  >
                    {state.optionCompanies.map((company) => (
                      <MenuItem
                        key={company.email}
                        value={company.email}
                        style={{
                          fontWeight:
                            state.company != company.email ? "normal" : "500",
                        }}
                      >
                        {company.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Fragment>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputLabel htmlFor="shiftTypes">Dienstsoorten *</InputLabel>
              <Select
                id="shiftTypes"
                name="shiftTypes"
                multiple
                value={state.shiftTypes}
                onChange={handleEmployeeChange}
                fullWidth
              >
                {state.optionShiftTypes.map((shiftType) => (
                  <MenuItem
                    key={shiftType.id}
                    value={shiftType.id}
                    style={{
                      fontWeight:
                        state.shiftTypes.indexOf(shiftType.id) === -1
                          ? "normal"
                          : "500",
                    }}
                  >
                    {shiftType.name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>Meerdere selecteren is mogelijk</FormHelperText>
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputLabel htmlFor="employmentType">
                Type dienstverband *
              </InputLabel>
              <Select
                id="employmentType"
                name="employmentType"
                value={state.employmentType}
                onChange={(e) =>
                  setState((prev) => ({
                    ...prev,
                    employmentType: e.target.value || null,
                  }))
                }
                fullWidth
              >
                {Object.values(EmploymentType).map((v, i) => (
                  <MenuItem
                    key={i}
                    value={v}
                    style={{
                      fontWeight: state.employmentType === v ? "500" : "normal",
                    }}
                  >
                    {t(v)}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            <Grid item xs={12} sm={6}>
              <InputLabel htmlFor="commuteType">Type vervoer *</InputLabel>
              <Select
                id="commuteType"
                name="commuteType"
                value={state.commuteType}
                onChange={(e) =>
                  setState((prev) => ({
                    ...prev,
                    commuteType: e.target.value || null,
                  }))
                }
                fullWidth
              >
                {Object.values(CommuteType).map((v, i) => (
                  <MenuItem
                    key={i}
                    value={v}
                    style={{
                      fontWeight: state.commuteType === v ? "500" : "normal",
                    }}
                  >
                    {t(v)}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    id="isEmployeeInEducation"
                    name="isEmployeeInEducation"
                    checked={state.isEmployeeInEducation}
                    onChange={handleCheckboxChange}
                  />
                }
                label="Medewerker in opleiding"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    id="isSeniorEmployee"
                    name="isSeniorEmployee"
                    checked={state.isSeniorEmployee}
                    onChange={handleCheckboxChange}
                  />
                }
                label="Seniormedewerker"
              />
            </Grid>
            {state.cardPhoto && (
              <img
                src={state.cardPhoto}
                style={{
                  width: "100%",
                  height: "100%",
                  margin: "0 auto",
                }}
              />
            )}

            {state.optionShiftTypes
              .filter((s) => state.shiftTypes.includes(s.id))
              .some((s) => s.isCardPhotoRequired) && (
              <Fragment>
                <Grid item xs={12} sm={12}>
                  <input
                    id="cardPhoto"
                    type="file"
                    accept="image/jpeg"
                    onChange={handleFileUploadChange}
                    style={{ display: "none" }}
                  />
                  <label htmlFor="cardPhoto">
                    <Button variant="contained" component="span">
                      <AttachFileIcon />
                      Upload medewerkerspas
                    </Button>
                  </label>

                  {state.cardPhoto !== "" && (
                    <Button
                      component="span"
                      onClick={() =>
                        setState((prev) => ({ ...prev, cardPhoto: "" }))
                      }
                    >
                      <DeleteIcon />
                      Verwijder foto
                    </Button>
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="cardNumber"
                    name="cardNumber"
                    label="Pasnummer *"
                    value={state.cardNumber}
                    onChange={handleChange}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <KeyboardDatePicker
                    clearable
                    mask="__-__-____"
                    id="cardValidity"
                    name="cardValidity"
                    label="Pas geldig tot *"
                    value={state.cardValidity}
                    format={"L"}
                    onChange={(m) =>
                      setState((prev) => ({
                        ...prev,
                        cardValidity: m,
                      }))
                    }
                    fullWidth
                  />
                </Grid>
              </Fragment>
            )}
          </Grid>

          {!successMessage &&
            Array.isArray(errorMessage) &&
            errorMessage.length > 0 && (
              <Fragment>
                <br />

                <Grid item xs={12} sm={12}>
                  <div className="alert alert-info">
                    <ul>
                      <li>
                        Indien u problemen ondervindt met het toevoegen van een
                        medewerker kunt u hier een melding van maken bij{" "}
                        {settings.name}. Wij zullen hier zo snel mogelijk zorg
                        voor dragen.
                      </li>
                    </ul>
                  </div>

                  <Button onClick={notifyError} fullWidth>
                    Melding maken
                  </Button>
                </Grid>
              </Fragment>
            )}
        </Form>
      )}
    </AppContext.Consumer>
  );
};

CreateCompanyEmployeeForm.propTypes = {
  email: PropTypes.string.isRequired,
  company: PropTypes.string,
  assignEmployee: PropTypes.func.isRequired,
  getShiftTypes: PropTypes.func.isRequired,
  getCompanies: PropTypes.func.isRequired,
  getCompaniesOfEmployee: PropTypes.func.isRequired,
  notifyErrorCompanyEmployeeAssignment: PropTypes.func.isRequired,
};

export default connect(null, {
  assignEmployee,
  getShiftTypes,
  getCompanies,
  getCompaniesOfEmployee,
  notifyErrorCompanyEmployeeAssignment,
})(CreateCompanyEmployeeForm);



// WEBPACK FOOTER //
// ./src/components/forms/CreateCompanyEmployeeForm.js